<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Delete </span>
  </BaseButton>
</template>

<script>
import { projectAssetsClient } from '@/api/clients';

export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/ProjectAssets/ProjectAssetDeleteModal.vue'),
        props: {
          action: projectAssetsClient.destroy,
          projectAsset: this.projectAsset,
        },
        on: {
          'project-asset-deleted': (projectAsset) => {
            this.$emit('project-asset-deleted', projectAsset);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
